import React, { useEffect, useState } from 'react';
import { Menu, X, Flower, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const centerDropdownItems = [{
    name: 'About The Center',
    href: '/about'
  }, {
    name: 'Our Team',
    href: '/team'
  }, {
    name: 'Facilities',
    href: '/facilities'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-174">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-175">
        <div className="flex justify-between items-center" data-id="element-176">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group" data-id="element-177">
            <Flower className="h-8 w-8 text-[#D4AF37] transition-transform duration-500 group-hover:rotate-180" data-id="element-178" />
            <span className="font-serif text-2xl font-bold text-[#3A5F7D] tracking-wide" data-id="element-179">
              Supradhyan
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-180">
            {/* The Center - Dropdown */}
            <div className="relative" onMouseEnter={() => setIsDropdownOpen(true)} onMouseLeave={() => setIsDropdownOpen(false)} data-id="element-181">
              <button className="flex items-center gap-1 text-[#3A5F7D] hover:text-[#5B9BD5] font-medium transition-colors duration-200" data-id="element-182">
                The Center
                <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`} data-id="element-183" />
              </button>

              <AnimatePresence data-id="element-184">
                {isDropdownOpen && <motion.div initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: 10
              }} transition={{
                duration: 0.2
              }} className="absolute top-full left-0 mt-2 w-56 bg-white rounded-lg shadow-xl py-2 border border-[#C5E0F4]/40" data-id="element-185">
                    {centerDropdownItems.map((item, index) => <Link key={index} to={item.href} className="block px-4 py-3 text-[#3A5F7D] hover:bg-[#F5FAFD] hover:text-[#5B9BD5] transition-colors" data-id="element-186">
                        {item.name}
                      </Link>)}
                  </motion.div>}
              </AnimatePresence>
            </div>

            <Link to="/courses" className="text-[#3A5F7D] hover:text-[#5B9BD5] font-medium transition-colors duration-200" data-id="element-187">
              Courses
            </Link>
            <Link to="/satguru" className="text-[#3A5F7D] hover:text-[#5B9BD5] font-medium transition-colors duration-200" data-id="element-188">
              Satguru
            </Link>
            <Link to="/contact" className="text-[#3A5F7D] hover:text-[#5B9BD5] font-medium transition-colors duration-200" data-id="element-189">
              Contact
            </Link>
            <Link to="/donate" className="bg-[#5B9BD5] hover:bg-[#4A7FB8] text-white px-6 py-2 rounded-full font-medium transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg" data-id="element-190">
              Donate
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-[#3A5F7D]" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-191">
            {isMobileMenuOpen ? <X data-id="element-192" /> : <Menu data-id="element-193" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-194">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-[#C5E0F4]/40 overflow-hidden" data-id="element-195">
            <div className="px-4 py-6 space-y-4 flex flex-col items-center" data-id="element-196">
              {/* The Center Submenu */}
              <div className="w-full max-w-xs" data-id="element-197">
                <div className="text-lg text-[#C5E0F4] font-medium mb-2 text-center" data-id="element-198">
                  The Center
                </div>
                <div className="space-y-2 pl-4" data-id="element-199">
                  {centerDropdownItems.map((item, index) => <Link key={index} to={item.href} className="block text-[#3A5F7D] hover:text-[#5B9BD5] text-center py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-200">
                      {item.name}
                    </Link>)}
                </div>
              </div>

              <Link to="/courses" className="text-lg text-[#3A5F7D] font-medium hover:text-[#5B9BD5]" onClick={() => setIsMobileMenuOpen(false)} data-id="element-201">
                Courses
              </Link>
              <Link to="/satguru" className="text-lg text-[#3A5F7D] font-medium hover:text-[#5B9BD5]" onClick={() => setIsMobileMenuOpen(false)} data-id="element-202">
                Satguru
              </Link>
              <Link to="/contact" className="text-lg text-[#3A5F7D] font-medium hover:text-[#5B9BD5]" onClick={() => setIsMobileMenuOpen(false)} data-id="element-203">
                Contact
              </Link>
              <Link to="/donate" className="w-full max-w-xs bg-[#5B9BD5] text-white px-6 py-3 rounded-full font-medium mt-4 text-center" onClick={() => setIsMobileMenuOpen(false)} data-id="element-204">
                Donate
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}